import React from "react";

import { makeStyles, Grid, Typography, Button, Paper } from "@material-ui/core";

import platform from "platform";

const useStyles = makeStyles({
  welcomeContainer: {
    padding: "1em",
    minHeight: "300px"
  },
  welcomePaper: {
    padding: "1.5em",
    minHeight: "300px",
    zIndex: "10"
  },
  welcomeTextDiv: {
    paddingTop: "1em",
    minHeight: "200px",
    maxWidth: "800px",
    fontSize: "1.5em"
  },
  levrumLogo: {
    width: "15em"
  },
  logoDiv: {
    position: "fixed",
    bottom: "1em",
    right: "1em"
  },
  inlineMaterialIcon: {
    fontFamily: "Material Icons",
    verticalAlign: "Middle",
    fontSize: "1.25em"
  }
});

export default function NewVersionPage() {
  const classes = useStyles();
  return (
    <Grid
      className={classes.welcomeContainer}
      container
      direction="column"
      justify="center"
      alignItems="center"
    >
      <Paper className={classes.welcomePaper}>
        <Typography variant="h3">New Version Available!</Typography>
        <div className={classes.welcomeTextDiv}>
          A new version of the Code3 Firewatch app has been released since the
          last time you logged in.
          <br />
          <br />
          Please update by clicking the{" "}
          <span className={classes.inlineMaterialIcon}>home</span> icon, then
          refreshing the browser window by pressing{" "}
          <span className={classes.inlineMaterialIcon}>refresh</span> on your
          browser toolbar or Ctrl+R or &#8984;+R on your keyboard.
        </div>
      </Paper>
      <div className={classes.logoDiv}>
        <Button target="_new" href="https://levrum.com">
          <img className={classes.levrumLogo} src="/levrumlogo.svg" />
        </Button>
      </div>
    </Grid>
  );
}
